const movieRecommendationSystem = {
  fa: {
    header: {
      title: "سیستم پیشنهاد فیلم",
      intro:
        " یک سیستم پیشنهاد فیلم است که با استفاده از Behavior Sequence Transformer و چارچوب PyTorch توسعه داده شده و هدف آن استفاده از تاریخچه رفتار کاربران برای ایجاد پیشنهادهای دقیق‌تر است.",
      description: [
        "ایده اصلی پروژه بر این اساس است که رفتار گذشته کاربر، به‌ویژه ترتیب تعاملات او با محتوا، می‌تواند اطلاعات ارزشمندی درباره انتخاب بعدی او ارائه دهد. برخلاف سیستم‌هایی که تنها به ویژگی‌های کلی کاربر یا فیلم توجه می‌کنند، این مدل تلاش می‌کند الگوی رفتاری کاربر در طول زمان را نیز در نظر بگیرد.",

        "برای آموزش و ارزیابی مدل از مجموعه‌داده MovieLens 1M شامل یک میلیون امتیازدهی از حدود ۶۰۰۰ کاربر برای ۴۰۰۰ فیلم استفاده شده است. معماری پروژه بر اساس دو مقاله Behavior Sequence Transformer for E-commerce Recommendation in Alibaba و Attention Is All You Need طراحی شده است.",

        "این پروژه در قالب یک Notebook پیاده‌سازی شده و ساختار معماری مدل و لایه‌های مختلف آن نیز به صورت تصویری مستندسازی شده است.",
      ],
      image:
        "https://github.com/F-Yousefi/RecSys-BST-Pytorch/raw/main/images/header.jpg",
    },
    side: {
      Project: "سیستم پیشنهاد فیلم",
      LiveDemo: "https://github.com/F-Yousefi/RecSys-BST-Pytorch",
      Language: "انگلیسی",
      Date: "اسفند ۱۴۰۲",
      Technologies:
        "PyTorch · Behavior Sequence Transformer · Movie Recommendation · MovieLens 1M · Attention-Based Models · User Behavior Sequences",
    },
  },

  en: {
    header: {
      title: "Movie Recommendation System",
      intro:
        "Movie Recommendation System is a sequence-aware recommendation project built with PyTorch and the Behavior Sequence Transformer architecture, designed to use users' behavioral history to generate more meaningful movie recommendations.",
      description: [
        "The core idea is to consider not only what a user has interacted with, but also the sequence of their interactions over time. This allows the model to capture changes and patterns in user preferences that traditional recommendation approaches may overlook.",

        "The project uses the MovieLens 1M dataset, containing one million ratings from approximately 6,000 users across 4,000 movies. Its architecture is based on the papers Behavior Sequence Transformer for E-commerce Recommendation in Alibaba and Attention Is All You Need.",
        "The complete implementation is provided in a Jupyter Notebook, along with a visual representation of the model architecture and its individual layers.",
      ],
      image:
        "https://github.com/F-Yousefi/RecSys-BST-Pytorch/raw/main/images/header.jpg",
    },
    side: {
      Project: "Movie Recommendation System",
      LiveDemo: "https://github.com/F-Yousefi/RecSys-BST-Pytorch",
      Language: "English",
      Date: "December 2023",
      Technologies:
        "PyTorch · Movie Recommendation · MovieLens 1M · Attention-Based Models · User Behavior Sequences",
    },
  },
};

export default movieRecommendationSystem;
